import { useState, useEffect } from "react";
import { CandidatosItem } from "./CandidatosItem";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import SearchIcon from "@mui/icons-material/Search";
import NotesIcon from "@mui/icons-material/Notes";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import Navbar from "../Navbar";
import { useToast } from "../../Hooks/UseToast";
import { logEventos } from "../../services/services";

export default function ApplicantsView() {
  //const UrlApi = "http://localhost:27021/api"; //usoLocal
  const UrlApi = "https://empleosback.netizar.com/api"; //Ruta para produccion

  const { showToast, Toast } = useToast();

  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [applicants, setApplicants] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [stats, setStats] = useState({});

  const [provincias, setProvincias] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [localidades, setLocalidades] = useState([]);

  const [idProvinciaSeleccionada, setIdProvinciaSeleccionada] = useState(null);
  const [idLocalidadSeleccionada, setIdLocalidadSeleccionada] = useState(null);
  const [idPuestoSeleccionado, setIdPuestoSeleccionado] = useState(null);

  const fetchData = async () => {
    try {
      const [resProvincias, resPuestos] = await Promise.all([
        fetch(`${UrlApi}/provincias`),
        fetch(`${UrlApi}/puestos`),
      ]);

      const dataProvincias = await resProvincias.json();
      const dataPuestos = await resPuestos.json();

      setProvincias(dataProvincias.data);
      setPuestos(dataPuestos.data);
    } catch (error) {
      console.error("Error al cargar provincias o puestos:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchLocalidades = async (idProvincia) => {
    if (!idProvincia) return;
    try {
      const res = await fetch(`${UrlApi}/localidades/${idProvincia}`);
      const data = await res.json();
      setLocalidades(data.data);
    } catch (error) {
      console.error("Error al cargar localidades:", error);
    }
  };

  useEffect(() => {
    if (!idProvinciaSeleccionada) return;
    else {
      fetchLocalidades(idProvinciaSeleccionada);
    }
  }, [idProvinciaSeleccionada]);

  const fetchApplicants = async (page = 1, limit = 5) => {
    try {
      const params = new URLSearchParams();

      if (idProvinciaSeleccionada) {
        params.append("idProvincia", idProvinciaSeleccionada);
      }
      if (idLocalidadSeleccionada) {
        params.append("idLocalidad", idLocalidadSeleccionada);
      }
      if (idPuestoSeleccionado) {
        params.append("idPuesto", idPuestoSeleccionado);
      }

      params.append("page", page);
      params.append("limit", limit);

      const url = new URL(`${UrlApi}/?${params.toString()}`);
      if (searchTerm) url.searchParams.append("search", searchTerm);
      if (filterType !== "all") url.searchParams.append("filter", filterType);

      const response = await fetch(url.toString());
      const result = await response.json();

      setApplicants(result.data);
      setStats(result.stats);
      setPage(result.page);
      setTotalPages(result.totalPages);
    } catch (error) {
      console.error("Error fetching applicants:", error);
    }
  };

  useEffect(() => {
    fetchApplicants(page, 12); // 12 es el límite por página
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [
    page,
    searchTerm,
    filterType,
    idLocalidadSeleccionada,
    idProvinciaSeleccionada,
    idPuestoSeleccionado,
  ]);

  const handlePrev = () => {
    if (page > 1) setPage(Number(page) - 1);
  };

  const handleNext = () => {
    if (page < totalPages) setPage(Number(page) + 1);
  };

  useEffect(() => {
  logEventos(
    "acceso al menú CVs WEB",
   "RRHH", 
   "expo empleos CVs WEB", 
   localStorage.getItem("user"));
}, []);
  return (
    <>
      <Navbar />
      <Box sx={{ minHeight: "100vh", bgcolor: "grey.50", py: 6 }}>
        <Box sx={{ maxWidth: 1120, mx: "auto", px: 2 }}>
          {/* Header */}
          <Box sx={{ mb: 8 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <AssignmentIndIcon width={40} height={40} />
              </Box>
              <Typography
                variant="h4"
                fontWeight="bold"
                color="text.primary"
                sx={{ display: "flex", alignItems: "center" }}
              >
                Solicitantes de Empleo
              </Typography>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 6 }}>
              Lista de candidatos que han aplicado a las posiciones disponibles.
            </Typography>

            {/* Stats */}
            <Grid container spacing={3} sx={{ mb: 6 }}>
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    p: 3,
                    boxShadow: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <PersonIcon size={32} />
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {stats.total}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Total Candidatos
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    p: 3,
                    boxShadow: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <FilePresentIcon size={32} />
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {stats.withCV}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Con CV
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box
                  sx={{
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    p: 3,
                    boxShadow: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <NotesIcon size={32} />
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color="text.primary"
                    >
                      {stats.withDescription}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Con Descripción
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            {/* Filters */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 3,
                mb: 6,
              }}
            >
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Buscar por nombre, apellido o email..."
                value={searchTerm}
                onChange={(e) => {
                  setPage(1);
                  setSearchTerm(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon size={20} />
                    </InputAdornment>
                  ),
                }}
              />

              <Select
                value={filterType}
                onChange={(e) => {
                  setPage(1);
                  setFilterType(e.target.value);
                }}
                sx={{ minWidth: 180 }}
              >
                <MenuItem value="all">📋 Todos los candidatos</MenuItem>
                <MenuItem value="with-cv">📄 Con CV</MenuItem>
                <MenuItem value="without-cv">❌ Sin CV</MenuItem>
                <MenuItem value="with-description">👤 Con descripción</MenuItem>
                <MenuItem value="without-description">
                  ❓ Sin descripción
                </MenuItem>
              </Select>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                mb: 4,
              }}
            >
              {/* Select: Provincia */}
              <Select
                value={idProvinciaSeleccionada || ""}
                onChange={(e) => {
                  setIdProvinciaSeleccionada(e.target.value);
                  setIdLocalidadSeleccionada(null);
                }}
                displayEmpty
                sx={{ minWidth: 180 }}
              >
                <MenuItem value="">🏳️ Todas las provincias</MenuItem>
                {(provincias || []).map((prov) => (
                  <MenuItem key={prov.id} value={prov.id}>
                    {prov.provincia}
                  </MenuItem>
                ))}
              </Select>

              {/* Select: Localidad */}
              <Select
                value={idLocalidadSeleccionada || ""}
                onChange={(e) => setIdLocalidadSeleccionada(e.target.value)}
                displayEmpty
                sx={{ minWidth: 180 }}
                disabled={!idProvinciaSeleccionada}
              >
                <MenuItem value="">🏙️ Todas las localidades</MenuItem>
                {(localidades || []).map((loc) => (
                  <MenuItem key={loc.id} value={loc.id}>
                    {loc.localidad}
                  </MenuItem>
                ))}
              </Select>

              {/* Select: Puesto */}
              <Select
                value={idPuestoSeleccionado || ""}
                onChange={(e) => setIdPuestoSeleccionado(e.target.value)}
                displayEmpty
                sx={{ minWidth: 180 }}
              >
                <MenuItem value="">💼 Todos los puestos</MenuItem>
                {(puestos || []).map((p) => (
                  <MenuItem key={p.id} value={p.id}>
                    {p.puesto}
                  </MenuItem>
                ))}
              </Select>
              <Button
                variant="contained"
                disabled={
                  !idLocalidadSeleccionada &&
                  !idProvinciaSeleccionada &&
                  !idPuestoSeleccionado
                }
                onClick={() => {
                  setSearchTerm("");
                  setFilterType("all");
                  setIdLocalidadSeleccionada("");
                  setIdProvinciaSeleccionada("");
                  setIdPuestoSeleccionado("");
                }}
              >
                Limpiar filtros
              </Button>
            </Box>
          </Box>

          {/* Results */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Mostrando {applicants.length} de {stats.total} candidatos
          </Typography>

          {/* Applicants Grid */}
          {applicants.length > 0 ? (
            <>
              <Grid container spacing={3}>
                {applicants.map((applicant, index) => (
                  <Grid
                    item
                    xs={12}
                    lg={6}
                    xl={4}
                    key={`${applicant.email}-${applicant.nombre}-${index}`}
                  >
                    <CandidatosItem
                      puestosList={puestos}
                      showToast={showToast}
                      applicant={applicant}
                      index={index}
                      localidades={localidades}
                      provincias={provincias}
                      obtenerCandidatos={fetchApplicants}
                    />
                  </Grid>
                ))}
              </Grid>

              <Box
                sx={{
                  mt: 6,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<ChevronLeftIcon size={20} />}
                  onClick={handlePrev}
                  disabled={page === 1}
                  sx={{
                    textTransform: "none",
                    bgcolor: "blue.100",
                    color: "blue.700",
                    "&:hover": {
                      bgcolor: "blue.200",
                    },
                    "&.Mui-disabled": {
                      opacity: 0.5,
                      bgcolor: "blue.100",
                      color: "blue.700",
                    },
                  }}
                >
                  Anterior
                </Button>

                <Typography variant="body2" color="text.secondary">
                  Página {page} de {totalPages}
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRightIcon size={20} />}
                  onClick={handleNext}
                  disabled={page === totalPages}
                  sx={{
                    textTransform: "none",
                    bgcolor: "blue.100",
                    color: "blue.700",
                    "&:hover": {
                      bgcolor: "blue.200",
                    },
                    "&.Mui-disabled": {
                      opacity: 0.5,
                      bgcolor: "blue.100",
                      color: "blue.700",
                    },
                  }}
                >
                  Siguiente
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box
                sx={{
                  textAlign: "center",
                  py: 12,
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                  <ErrorOutlineIcon height={80} width={80} />
                </Box>
                <Typography variant="h6" fontWeight="medium" sx={{ mb: 2 }}>
                  No se encontraron candidatos
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 4 }}
                >
                  Intenta ajustar los filtros de búsqueda.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setSearchTerm("");
                    setFilterType("all");
                    setIdLocalidadSeleccionada("");
                    setIdProvinciaSeleccionada("");
                    setIdPuestoSeleccionado("");
                  }}
                  sx={{ textTransform: "none" }}
                >
                  Limpiar filtros
                </Button>
              </Box>

              <Box
                sx={{
                  mt: 6,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<ChevronLeftIcon size={20} />}
                  onClick={handlePrev}
                  disabled={page === 1}
                  sx={{
                    textTransform: "none",
                    bgcolor: "blue.100",
                    color: "blue.700",
                    "&:hover": {
                      bgcolor: "blue.200",
                    },
                    "&.Mui-disabled": {
                      opacity: 0.5,
                      bgcolor: "blue.100",
                      color: "blue.700",
                    },
                  }}
                >
                  Anterior
                </Button>

                <Typography variant="body2" color="text.secondary">
                  Página {page} de {totalPages}
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRightIcon size={20} />}
                  onClick={handleNext}
                  disabled={page === totalPages}
                  sx={{
                    textTransform: "none",
                    bgcolor: "blue.100",
                    color: "blue.700",
                    "&:hover": {
                      bgcolor: "blue.200",
                    },
                    "&.Mui-disabled": {
                      opacity: 0.5,
                      bgcolor: "blue.100",
                      color: "blue.700",
                    },
                  }}
                >
                  Siguiente
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {Toast}
    </>
  );
}
